module.exports = __webpack_public_path__ + "static/img/bread.57e44a91.png";